var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "	you\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("/home/travis/build/thelounge/lounge/client/views/user_name.tpl"),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.invited : depth0)},"data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = container.invokePartial(require("/home/travis/build/thelounge/lounge/client/views/user_name.tpl"),depth0,{"name":"../user_name","hash":{"nick":(depth0 != null ? depth0.from : depth0)},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "invited\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.invitedYou : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "to\n"
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/parse.js")).call(alias1,(depth0 != null ? depth0.channel : depth0),{"name":"parse","hash":{},"data":data})) != null ? stack1 : "")
    + "\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/actions/invite.tpl
// module id = 220
// module chunks = 0